"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MessageSquare, Clock, MapPin, Briefcase, ShieldCheck, Settings } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  id: "item-1",
  question: "Quali sono i tempi di risposta per le emergenze critiche?",
  answer: "Per i clienti con contratto di supporto attivo, garantiamo tempi di presa in carico rapidi (SLA definiti in fase contrattuale), tipicamente entro 2-4 ore per blocchi critici dell'infrastruttura. Per richieste standard, la gestione avviene entro il giorno lavorativo successivo.",
  icon: <Clock className="size-5 text-primary" />
}, {
  id: "item-2",
  question: "Fornite supporto on-site o solo da remoto?",
  answer: "Adottiamo un approccio ibrido. La maggior parte delle attività di manutenzione e troubleshooting viene gestita da remoto per garantire velocità ed efficienza. Tuttavia, interveniamo on-site per deployment fisici, guasti hardware o configurazioni complesse in ambienti logistici e magazzini.",
  icon: <MapPin className="size-5 text-primary" />
}, {
  id: "item-3",
  question: "Come sono strutturati i modelli di ingaggio?",
  answer: "Offriamo due modelli principali: 'A Progetto' per migrazioni, audit o implementazioni specifiche, e 'Supporto Continuativo' (Retainer) per la gestione ordinaria, il monitoraggio e la governance IT mensile. Ogni soluzione è personalizzata in base alle esigenze dell'azienda.",
  icon: <Briefcase className="size-5 text-primary" />
}, {
  id: "item-4",
  question: "Gestite anche dispositivi industriali e scanner?",
  answer: "Sì, B-Tech ha una forte specializzazione nelle tecnologie operative (OT). Supportiamo scanner RF, stampanti termiche industriali, terminali veicolari e sistemi di pesatura integrati nei flussi di magazzino e produzione.",
  icon: <Settings className="size-5 text-primary" />
}, {
  id: "item-5",
  question: "Collaborate con il reparto IT interno dell’azienda?",
  answer: "Assolutamente. L'analisi dell'infrastruttura e della postura di sicurezza è spesso il primo passo del nostro metodo di lavoro. Eseguiamo una valutazione completa per identificare vulnerabilità, rischi e aree di miglioramento prima di proporre interventi correttivi.",
  icon: <ShieldCheck className="size-5 text-primary" />
}];
export default function FaqTecniche() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="faq-tecniche" className="dark bg-background text-foreground py-20 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
        <div className="absolute top-10 right-10 w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
        <div className="absolute bottom-10 left-10 w-64 h-64 bg-secondary/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground">
              Domande Frequenti
            </h2>
            <p className="text-muted-foreground text-lg">
              Risposte tecniche su operatività, SLA e modalità di collaborazione.
            </p>
          </div>

          <div className="bg-card/30 backdrop-blur-sm border border-border/50 rounded-xl p-6 md:p-8 shadow-lg">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, i) => <AccordionItem key={item.id} value={item.id} className="border-border/40 last:border-0 px-2" data-index={i}>
                  <AccordionTrigger className="hover:no-underline hover:bg-accent/5 px-4 rounded-lg transition-colors py-5 text-left">
                    <div className="flex items-center gap-4 text-base md:text-lg font-medium text-foreground/90">
                      <span className="shrink-0 mt-0.5 opacity-80">{item.icon}</span>
                      <span>{item.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-6 pt-2 text-muted-foreground text-base leading-relaxed pl-[3.25rem]">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground mb-6">
              Non hai trovato la risposta che cercavi?
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-md shadow-primary/20">
                <Link to="/ContactsPage">
                  <MessageSquare className="mr-2 size-4" />
                  Contatta B-Tech
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-border hover:bg-accent hover:text-accent-foreground">
                <Link to="/ServicesPage">
                  Esplora i Servizi
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}